import { TTagsManager } from '../../types/tag';
import { getTermValue, resetTerms } from '../../../../JsonQuery';
import { createTagValue } from '../../utils/createTagValue';

const ID = 'kpId' as const;

export const kpIdTagManager: TTagsManager = {
  id: ID,
  extractTagsFromJsonQuery: ({ jsonQuery, geoTags }) => {
    const kpId = getTermValue('kp_id')(jsonQuery);

    if (kpId === null) {
      return null;
    }

    const villageName = geoTags.village[kpId];

    const label = villageName || `Коттеджный посёлок №${kpId}`;

    return [{ label, value: createTagValue(ID) }];
  },
  modifyJsonQueryByRemovingTag: ({ jsonQuery }) => resetTerms(['kp_id'])(jsonQuery),
};
